import { makeGetRequest } from 'owa-ows-gateway';
import { UserMDollarSubscriptionResponse } from './UserMDollarSubscriptionResponse';

const GET_SUBSCRIPTION_URL: string = 'ows/api/beta/PremiumSubscription/MDollar';
let getUserMDollarSubscriptionPromise: Promise<UserMDollarSubscriptionResponse>;

export async function getUserMDollarSubscription(): Promise<UserMDollarSubscriptionResponse> {
    if (!getUserMDollarSubscriptionPromise) {
        getUserMDollarSubscriptionPromise = makeGetRequest(GET_SUBSCRIPTION_URL);
    }
    return getUserMDollarSubscriptionPromise;
}
